module.exports = __webpack_public_path__ + "img/1_026.2f714ac3.jpg";